import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store";
import {
  DEFAULT_SMS_COUNTRY_CODE,
  ONFIDO_CONTAINER_NAME,
  DEFAULT_LANGUAGE,
} from "../constants";

const selectOnfido = (state: RootState) => state.onfido;

export const selectOnfidoState = createSelector(
  selectOnfido,
  onfidoState => onfidoState || {},
);

export const selectCurrentPhase = createSelector(
  selectOnfidoState,
  onfidoState => {
    const { currentPhaseIndex, phases } = onfidoState;
    return phases?.[currentPhaseIndex];
  },
);

export const selectConfig = createSelector(selectCurrentPhase, currentPhase => {
  const { token, steps } = currentPhase || {};
  if (!token || !steps?.length) return undefined;
  return {
    token,
    containerId: ONFIDO_CONTAINER_NAME,
    steps,
    smsNumberCountryCode: DEFAULT_SMS_COUNTRY_CODE,
    language: DEFAULT_LANGUAGE,
  };
});

const selectPhaseType = createSelector(selectCurrentPhase, currentPhase => {
  const { steps } = currentPhase || {};
  if (!steps?.length) return undefined;
  return steps[0].type;
});

const selectSubStep = createSelector(selectOnfidoState, onfidoState => {
  const { subStep } = onfidoState;
  return subStep;
});

const selectIsCrossDevice = createSelector(selectOnfidoState, onfidoState => {
  const { isCrossDevice } = onfidoState;
  return isCrossDevice;
});

const selectHasError = createSelector(selectOnfidoState, onfidoState => {
  const { hasError } = onfidoState;
  return hasError;
});

export const selectIsFirstPhaseStep = createSelector(
  selectSubStep,
  selectIsCrossDevice,
  selectHasError,
  selectPhaseType,
  (subStep, isCrossDevice, hasError, phaseType) => {
    if (!subStep || !phaseType || hasError) return true;
    if (phaseType === "face" && subStep === "MOTION_FACIAL_INTRO") return true;
    if (phaseType === "face" && subStep === "CROSS_DEVICE_INTRO") return false;
    if (!["face", "document"].includes(phaseType)) return true;
    if (!isCrossDevice && subStep === "VIDEO_FACIAL_INTRO") return true;
    if (
      isCrossDevice &&
      ["CROSS_DEVICE_INTRO", "MOTION_FACIAL_INTRO"].includes(subStep)
    ) {
      return true;
    }
    return false;
  },
);
